<script>
import Layout from "@/router/layouts/auth";
import { mapState } from "vuex";
import Languages from "@/components/widgets/languages";
import EcosystemBrandCard from "@/components/widgets/ecosystem-brand-card";
import EcosystemUserMenu from "@/components/widgets/ecosystem-user-menu";

export default {
  locales: {
    pt: {
      'Hello': 'Olá',
      'Where do you want to start?': 'Por onde você quer começar?',
      'Choose a vertical of the Nexteev ecosystem.': 'Escolha uma vertical do ecossistema Nexteev.',
      'PRODUCTS': 'PRODUTOS',
      'SERVICES': 'SERVIÇOS',
      'VERTICAL OF': 'VERTICAL DE',
      'Premium supplements': 'Suplementação premium',
      'Perfumes and cosmetics': 'Perfumaria e cosméticos',
      'Travel and experiences': 'Viagens e experiências',
      'Technology and AI': 'Tecnologia e IA',
      'Scalable brands connected by a powerful affiliate program.': 'Marcas escaláveis conectadas por um poderoso programa de afiliados.',
      'Go to virtual office': 'Ir para o escritório virtual',
    },
    es: {
      'Hello': 'Hola',
      'Where do you want to start?': '¿Por dónde quieres empezar?',
      'Choose a vertical of the Nexteev ecosystem.': 'Elige una vertical del ecosistema Nexteev.',
      'PRODUCTS': 'PRODUCTOS',
      'SERVICES': 'SERVICIOS',
      'VERTICAL OF': 'VERTICAL DE',
      'Premium supplements': 'Suplementación premium',
      'Perfumes and cosmetics': 'Perfumería y cosméticos',
      'Travel and experiences': 'Viajes y experiencias',
      'Technology and AI': 'Tecnología e IA',
      'Scalable brands connected by a powerful affiliate program.': 'Marcas escalables conectadas por un poderoso programa de afiliados.',
      'Go to virtual office': 'Ir a la oficina virtual',
    },
  },
  components: {
    Layout,
    Languages,
    EcosystemBrandCard,
    EcosystemUserMenu,
  },
  data() {
    return {
      verticals: [
        {
          key: "products",
          title: "PRODUCTS",
          brands: [
            { name: "Nutriteev", logo: require("@/assets/images/brands/nutriteev.svg"), tagline: "Premium supplements", color: "#0B8A4A", status: "launched", to: "/store" },
            { name: "Nateev", logo: require("@/assets/images/brands/nateev.svg"), tagline: "Perfumes and cosmetics", color: "#C2185B", status: "soon" },
          ],
        },
        {
          key: "services",
          title: "SERVICES",
          brands: [
            { name: "Tripteev", logo: require("@/assets/images/brands/tripteev.svg"), tagline: "Travel and experiences", color: "#FFC700", status: "launched", to: "/tripteev" },
            { name: "Disrupteev", logo: require("@/assets/images/brands/disrupteev.svg"), tagline: "Technology and AI", color: "#7C4DFF", status: "soon" },
          ],
        },
      ],
    };
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
    // Escritório virtual só para quem já tem pacote (package.id > 1)
    hasOffice() {
      const user = this.account.user;
      return !!(user && user.package && user.package.id > 1);
    },
    firstName() {
      const user = this.account.user;
      return user && user.name ? user.name.split(" ")[0] : "";
    },
  },
};
</script>

<template>
  <Layout>
    <div class="ecosystem">
      <header class="ecosystem-header">
        <img class="ecosystem-logo" src="@/assets/images/logo.png" alt="Nexteev" />
        <div class="ecosystem-actions">
          <Languages type="right"></Languages>
          <EcosystemUserMenu></EcosystemUserMenu>
        </div>
      </header>

      <main class="ecosystem-main">
        <div class="ecosystem-intro">
          <h1 class="ecosystem-title">{{ t('Hello') }}<template v-if="firstName">, {{ firstName }}</template>! {{ t('Where do you want to start?') }}</h1>
          <p class="ecosystem-subtitle">{{ t('Choose a vertical of the Nexteev ecosystem.') }}</p>
        </div>

        <div class="ecosystem-verticals">
          <section v-for="vertical in verticals" :key="vertical.key" class="ecosystem-vertical" :aria-labelledby="'vertical-' + vertical.key">
            <h2 :id="'vertical-' + vertical.key" class="ecosystem-vertical-title">
              <span>{{ t('VERTICAL OF') }}</span>
              <strong>{{ t(vertical.title) }}</strong>
            </h2>
            <div class="ecosystem-brands">
              <EcosystemBrandCard
                v-for="brand in vertical.brands"
                :key="brand.name"
                :name="brand.name"
                :logo="brand.logo"
                :tagline="t(brand.tagline)"
                :color="brand.color"
                :status="brand.status"
                :to="brand.to || ''"
              />
            </div>
          </section>
        </div>

        <p class="ecosystem-footnote">{{ t('Scalable brands connected by a powerful affiliate program.') }}</p>

        <div v-if="hasOffice" class="ecosystem-office">
          <router-link to="/" class="btn btn-outline-default text-uppercase">{{ t('Go to virtual office') }}</router-link>
        </div>
      </main>
    </div>
  </Layout>
</template>
